/**

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

import { forwardRef } from "react";
import type { ComponentProps, ElementType } from "react";
import type { BoxProps } from "@mui/material/Box";

// Custom styles for VuiBox
import VuiBoxRoot from "components/VuiBox/VuiBoxRoot";

type OwnerState = ComponentProps<typeof VuiBoxRoot>["ownerState"];

type VuiBoxProps = Omit<BoxProps, keyof OwnerState> &
  Partial<OwnerState> & {
    component?: ElementType;
    // With a router link `component`: passed through to the link.
    to?: string;
    // With component="img": passed through to the image.
    src?: string;
    alt?: string;
  };

const VuiBox = forwardRef<HTMLDivElement, VuiBoxProps>(
  (
    {
      variant = "contained",
      bgColor = "transparent",
      color = "dark",
      opacity = 1,
      borderRadius = "none",
      shadow = "none",
      ...rest
    },
    ref
  ) => (
    <VuiBoxRoot
      {...rest}
      ref={ref}
      ownerState={{ variant, bgColor, color, opacity, borderRadius, shadow }}
    />
  )
);

export default VuiBox;
